import Vue from 'vue'
import App from './App.vue'
import { router } from './router';
import dayjs from 'dayjs'
import './utils/plugin'
import { Base64 } from 'js-base64';

// 移动端适配-设置根元素font-size
import "lib-flexible";

Vue.prototype.$dayjs = dayjs

Vue.config.productionTip = false
Vue.prototype.$base64 = Base64

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
